/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckCircleCutIcon16Light } from './CheckCircleCutIcon16Light';
import { CheckCircleCutIcon16Regular } from './CheckCircleCutIcon16Regular';
import { CheckCircleCutIcon16Solid } from './CheckCircleCutIcon16Solid';
import { CheckCircleCutIcon20Light } from './CheckCircleCutIcon20Light';
import { CheckCircleCutIcon20Regular } from './CheckCircleCutIcon20Regular';
import { CheckCircleCutIcon20Solid } from './CheckCircleCutIcon20Solid';
import { CheckCircleCutIcon24Regular } from './CheckCircleCutIcon24Regular';
import { CheckCircleCutIcon24Solid } from './CheckCircleCutIcon24Solid';
import { CheckCircleCutIcon32Regular } from './CheckCircleCutIcon32Regular';
import { CheckCircleCutIcon64Regular } from './CheckCircleCutIcon64Regular';
var sizes = {
    16: {
        light: CheckCircleCutIcon16Light,
        regular: CheckCircleCutIcon16Regular,
        solid: CheckCircleCutIcon16Solid,
    },
    20: {
        light: CheckCircleCutIcon20Light,
        regular: CheckCircleCutIcon20Regular,
        solid: CheckCircleCutIcon20Solid,
    },
    24: {
        regular: CheckCircleCutIcon24Regular,
        solid: CheckCircleCutIcon24Solid,
    },
    32: {
        regular: CheckCircleCutIcon32Regular,
    },
    64: {
        regular: CheckCircleCutIcon64Regular,
    },
};
export var CheckCircleCutIcon = forwardRef('CheckCircleCutIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
